import React from 'react';

const SvgArrowRight = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" width="2.4rem" height="2.4rem">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M6 12H18M18 12L13 7M18 12L13 17"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  );
};

export default SvgArrowRight;
